var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIconWithBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "#E6EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.314 20.9313L22.0443 21.278L22.3533 21.5901L26.3671 25.645C26.4558 25.7424 26.5029 25.8692 26.4999 25.9992C26.4967 26.1313 26.4419 26.2577 26.3459 26.3515C26.2498 26.4453 26.1199 26.499 25.9835 26.5C25.8493 26.5009 25.7206 26.4508 25.6236 26.3611L21.612 22.3105L21.3058 22.0013L20.9573 22.2619C19.5082 23.3454 17.6979 23.8422 15.8929 23.651C14.0879 23.4598 12.4244 22.595 11.2388 21.2328C10.0533 19.8707 9.4341 18.1131 9.50556 16.3159C9.57703 14.5186 10.3339 12.8148 11.624 11.5495C12.9143 10.2841 14.6414 9.5521 16.456 9.50267C18.2707 9.45325 20.0358 10.0902 21.3941 11.2835C22.7523 12.4768 23.6022 14.137 23.7729 15.9277C23.9435 17.7184 23.4223 19.5069 22.314 20.9313ZM16.6521 22.6651C18.2718 22.6651 19.8259 22.0264 20.9724 20.8885C22.1189 19.7504 22.7638 18.2061 22.7638 16.595C22.7638 14.9839 22.1189 13.4395 20.9724 12.3015C19.8259 11.1635 18.2718 10.5249 16.6521 10.5249C15.0323 10.5249 13.4782 11.1635 12.3318 12.3015C11.1852 13.4395 10.5404 14.9839 10.5404 16.595C10.5404 18.2061 11.1852 19.7504 12.3318 20.8885C13.4782 22.0264 15.0323 22.6651 16.6521 22.6651Z",
    fill: "#0466C8",
    stroke: "#0466C8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconWithBg);
export default __webpack_public_path__ + "static/media/searchIconWithBg.172d6228.svg";
export { ForwardRef as ReactComponent };